/* global angular */

/**
 * PreviewService
 *
 * Preview is enabled by configuring a variant containing the content types that should be
 * previewable. Expects the configured variant 'webViewVariant' to return a content with
 * an aspect, 'webView', that has a property 'contentPath' containing a pathname that is
 * appended to the 'webViewBaseUrl' value.
 *
 * Configuration:
 * @example
 * {
 *   ...
 *   "WebViewService": {
 *     "webViewBaseUrl": "https://myCoolWebsite.org",
 *     "webViewVariant": "MyCoolWebsiteUrl"
 *   }
 *   ...
 * }
 *
 */
angular.module('atex.aceui.service').factory('WebViewService',
  ['$q', 'ApplicationConfigurationService', 'ContentURLService',

    function ($q, ApplicationConfigurationService, ContentURLService) {
      return {
        async isEnabled () {
          const webViewConf = await ApplicationConfigurationService.getServiceConfigurationFor ('WebViewService');
          return $q.resolve (!!(webViewConf.webViewVariant && webViewConf.webViewBaseUrl));
        },
        /**
        * Get a URL to the content with 'alias' in the context of a configured
        * web view.
        *
        * @param {string} workspace - the workspace to use for the preview
        * @param {string} alias - the alias of the content to get a preview for
        *
        * @return { url: string }
        * @throws atex.aceui.error.Error
        **/
        async webView ({ alias }) {
          const webViewConfig = await ApplicationConfigurationService.getServiceConfigurationFor ('WebViewService');
          const config = {
            aspectName: 'webView',
            baseURL: webViewConfig.webViewBaseUrl,
            variant: webViewConfig.webViewVariant,
          };

          const response = await ContentURLService.getContentURL ({ alias, config });
          return $q.resolve (response);
        },
        /**
       * Checks whether a content is associated with a web view. It is considered to be
       * that if we can fetch it in a configured webViewVariant.
       *
       * @param {string} alias - content to check whether previewable or not
       * @param {string} workspace - the workspace to fetch the content through
       *
       * @return {boolean}
       * @throws atex.aceui.error.Error
       */
        async hasWebView ({ alias }) {
          try {
            const response = await this.webView ({ alias });
            return $q.resolve (!!(response && response.url));
          } catch (error) {
            if (error.type === atex.aceui.error.types.NOT_FOUND) {
              return $q.resolve (false);
            }
            throw error;
          }
        }
      };
    }
  ]);
